import { inject, Injectable } from '@angular/core';

import jwt_decode from 'jwt-decode';
import { LocalStorageService } from 'ngx-webstorage';
import { LoginResponseInterface } from '../../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class TokenAbstractService {
  protected tokenStorageKey;

  protected localStorageService: LocalStorageService = inject(LocalStorageService);

  abstract setToken(token: LoginResponseInterface): void;

  abstract getValidToken(): Observable<string | null>;

  abstract getWebsiteId(encodedToken?: string): number | null;

  abstract getEmail(encodedToken?: string): string | null;

  abstract getRole(): string | string[] | null;

  removeToken(): void {
    this.localStorageService.clear(this.tokenStorageKey);
  }

  isHoldingAToken(): boolean {
    return !!this.retrieveToken();
  }

  protected decodeJWT<DecodedJWTInterface>(token: string): DecodedJWTInterface {
    return jwt_decode(token);
  }

  protected retrieveToken<TokenInterface>(): TokenInterface {
    return this.localStorageService.retrieve(this.tokenStorageKey);
  }

  protected isTokenExpired(token: string): boolean {
    const [, encodedPayload] = token.split('.');
    const payload = JSON.parse(atob(encodedPayload));
    const expiryTimestamp = payload.exp;
    const currentTimestamp = Math.floor(new Date().getTime() / 1000);

    return currentTimestamp >= expiryTimestamp;
  }
}
